<header class="navhead navy-blue">
  <div class="sidelogo navy-blue">
    <button class="mini-sidetoggle open-menu">
      <i class="fa fa-angle-double-left"></i>
    </button>
    <button class="mini-sidetoggle close-menu">
      <i class="fa fa-angle-double-right"></i>
    </button>
  </div>
  <ul class="lifehead-cycle">
    <li>
      <a>
        <img class="head_isolve" src="" alt="" />
      </a>
    </li>
  </ul>
</header>



<!-- <header class="navhead navy-blue">
  <div class="sidelogo navy-blue">
    <a href="javascript:void(0)">
      <img
        src="\assets\images\logo_w.png"
        alt=""
        class="max-img"
      />
      <img
        src="\assets\images\logo_w_mini.png"
        alt=""
        class="mini-img"
      />
    </a>
    <button class="mini-sidetoggle open-menu">
      <i class="fa fa-angle-double-left"></i>
    </button>
    <button class="mini-sidetoggle close-menu">
      <i class="fa fa-angle-double-right"></i>
    </button>
  </div>
  <div class="select-drop">
    <i class="fa fa-map-marker"></i>
    <select name="city" class="">
      <option value="">Choose your city</option>
      <option *ngFor="let city of citieslist.respList" [value]="city.lc_CM_ID">{{city.lc_CM_CITY_NAME}}</option>
    </select>
  </div>

  <ul class="lifehead-cycle">
    <li>
      <ngx-flag-picker
      [selectedCountryCode]="selectedCountryCode"
      [countryCodes]="countryCodes"
      [showLabels]="true"
      [showFlags]="true"
      (changedCountryCode)="changeSelectedCountryCode($event)">
    </ngx-flag-picker>
    </li>
    <li class="head-notify">
      <a><i class="fa fa-bell"></i><span class="offline"></span></a>
    </li>
    <li>
      <div class="droptop" ngbDropdown>
        <button class="head-setting" id="gfg" ngbDropdownToggle>
          <i class="fa fa-user-circle usersiz"></i>{{username.Technician_Name}}
        </button>
        <div ngbDropdownMenu="gfg">
          <button ngbDropdownItem>Profile</button>
          <button ngbDropdownItem>Settings</button>
          <button ngbDropdownItem (click)="logout()">Logout</button>
        </div>
      </div>
       <a><i class="fa fa-user-circle"></i>Admin</a>
    </li>
    <li>
      <a><img class="head_isolve" src="\assets\images\isolve.png" alt="" /></a>
    </li>
  </ul>
</header> -->